import { HexaV2DropdownMenuOptions } from '@honeycomb-web/react/hexa-v2'
import { StyledDropdownForm, StyledDropdownMenu } from './styles'
import useHexaV2DropdownWithSearch from './useHexaV2DropdownWithSearch'

import type { HexaV2DropdownWithSearchProps } from './types'

const HexaV2DropdownWithSearch = ({
  id,
  name,
  label,
  placeholder,
  searchPlaceholder,
  value,
  disabled = false,
  'data-testid': dataTestId,
  items,
  onChange,
  height = 'min',
  size = 'medium',
  className,
}: HexaV2DropdownWithSearchProps) => {
  const {
    dropdownClassName,
    dropdownInstanceKey,
    dropdownMenuRef,
    filteredItems,
    handleClearSearch,
    handleDropdownOpen,
    handleInputSearch,
    handleOptionChange,
    selectedLabel,
  } = useHexaV2DropdownWithSearch({
    className,
    disabled,
    items,
    onChange,
    placeholder,
    searchPlaceholder,
    value,
  })

  return (
    <StyledDropdownForm
      key={dropdownInstanceKey}
      className={dropdownClassName}
      data-testid={dataTestId}
      id={id}
      name={name}
      label={label}
      value={value}
      placeholder={selectedLabel}
      size={size}
      disabled={disabled}
      // Workaround for Honeycomb hardcoding the search placeholder as "Search"
      onHxOpen={handleDropdownOpen}
    >
      {disabled ? null : (
        <StyledDropdownMenu
          ref={dropdownMenuRef}
          slot="dropdown-menu"
          className="hexa-v2-dropdown-with-search-menu"
          height={height}
          size={size}
          style={{
            position: 'absolute',
            top: 'calc(100% + var(--space-1))',
            left: 0,
            right: 0,
            zIndex: 'var(--z-index-dropdown-menu)',
          }}
          search
          selectAll={false}
          optionsType="single"
          onHxOptionChange={handleOptionChange}
          onHxInputSearch={handleInputSearch}
          onHxClearSearch={handleClearSearch}
        >
          {filteredItems.length > 0 ? (
            filteredItems.map(item => (
              <HexaV2DropdownMenuOptions
                key={item.id}
                hxId={item.id}
                option={item.label}
                selected={item.id === value || item.selected}
                disabled={disabled || item.disabled}
              />
            ))
          ) : (
            <HexaV2DropdownMenuOptions optionType="not-found" />
          )}
        </StyledDropdownMenu>
      )}
    </StyledDropdownForm>
  )
}

export default HexaV2DropdownWithSearch
